import React from 'react';
import { Text, ProgressCircle } from "@react-spectrum/s2";
import { useTranslation } from 'react-i18next';
export const AuthLoadingView: React.FC = ()=>{
    const { t } = useTranslation();
    return (<div className={" Mc171"} style={{
        backgroundColor: 'var(--color-bg-primary)'
    }}>
    <div className={" sd171 _ta171 eb171 _Ca171 Fc171"}>
      <ProgressCircle aria-label={t('settings.authLoading.loading')} isIndeterminate size="L"/>
      <Text styles={" JC171"}>{t('settings.authLoading.loading')}</Text>
    </div>
  </div>);
};

import "macro-18df3d57259a18be80d73e75a3827619027165ca1ee17d2353026148c34c3a68.css";
import "macro-e234e8444d9fa49e8a0ed6d970005f7de172c6dd458f8ed001a7a25b0983ea5d.css";
import "macro-b8e47d7d49f15e4061d1b8c771b49b4cad42981c0564770fa8e46e6f1784ca3d.css";